import React, { useEffect, useContext } from 'react'
import axios from 'axios'
import { Router } from '@reach/router';
import Auth from './component/Auth';
import Home from './Screens/Home';
import About from './Screens/About';
import { Route } from 'router';

import { PresignedUrlProvider } from './context/PresignedUrlContext';
import { Context as UserContext } from './context/UserContext';
import Help from './Screens/Help';

const App = () => {

  const [user, setUser] = useContext(UserContext);

  useEffect(() => {
    axios
      .get('api/user', { withCredentials: true })
      .then((res) => {
        setUser(res.data);
      })
      .catch((e) => {
        console.log('error: ', e)
      });
  }, []);

  return (
    <>
      {user ? (
        <>
          <PresignedUrlProvider>
            <Router>
              <Home path="/" user={user} />
              <About path="/about" user={user} />
              <Help path="/help" user={user} />
            </Router>
          </PresignedUrlProvider>
        </>
      ) : <Auth user={user} />}
    </>
  );
}

export default App;